export const SidebarDivider = () => (
  <div className="w-full px-2 py-1">
    <hr className="border-muted" />
  </div>
)
